export const SET_TRANSLATION_RESULTS = 'SET_TRANSLATION_RESULTS';
export const RESET_TRANSLATION_RESULTS = 'RESET_TRANSLATION_RESULTS';
